import React from 'react';

const COLORS = {
  'Annual Leave':        'bg-blue-50 text-blue-700',
  'Sick Leave':          'bg-red-50 text-red-600',
  'Remote Work':         'bg-violet-50 text-violet-700',
  'Unpaid Leave':        'bg-sand-200 text-sand-600',
  'Compassionate Leave': 'bg-pink-50 text-pink-700',
  'Parental Leave':      'bg-teal-50 text-teal-700',
};

export function LeaveTypeBadge({ type }) {
  const cls = COLORS[type] || 'bg-sand-100 text-sand-600';
  return (
    <span className={`inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full ${cls}`}>
      {type}
    </span>
  );
}
